export const DEFAULT_EXPORT_PAGE_SIZE = 500;

export const DEFAULT_EXPORT_WINDOW_MONTHS = 3;

export const getDefaultFromDate = (): string => {
  const d = new Date();

  d.setMonth(d.getMonth() - DEFAULT_EXPORT_WINDOW_MONTHS);

  return d.toISOString();
};

export const normalizeDeviceId = (id?: string): string => {
  if (!id) return "";

  return id.startsWith("DE#") ? id.slice(3) : id;
};

export const normalizeLocationId = (id: string): string => {
  const match = id.match(/L#([^#]+)$/);

  return match ? match[1] : id;
};
